<section class="Stepper">
  <div class="Stepper__StepContent">
    <cdk-stepper>
      @for (step of cdkSteps; track step) {
        <cdk-step [label]="step.label">
          @if (selected?.content) {
            <div>{{ step.description }}</div>
          }
        </cdk-step>
      }
    </cdk-stepper>
  </div>
  <div class="Stepper__StepsContainer Stepper__Desktop">
    <div class="Stepper__Steps container u-flex">
      @for (step of cdkSteps; track step; let i = $index, last = $last) {
        <ng-container>
          <div
            class="Stepper__StepItem"
            [class.Stepper__StepItem_Active]="selectedIndex === i"
            [class.Stepper__StepItem_Disabled]="!step.editable"
            (click)="selectStepByIndex(i)"
          >
            <div class="u-flex">
              <span class="Stepper__Step" [class.Stepper__StepLast]="last">
                {{ step.label }}
              </span>
            </div>
          </div>
          @if (!last) {
            <icon
              [config]="{ fill: 'move', type: 'svg' }"
              class="Stepper__StepIcon"
              [name]="'carat_right'"
            ></icon>
          }
        </ng-container>
      }
    </div>
  </div>

  <accordion
    class="Stepper__Mobile"
    [isOpen]="false"
    [config]="stepperMobileConfig"
    [headerTemplateTitle]="headerTemplateTitle"
    [subHeader]="subHeader"
  >
    <ng-container>
      <ng-template #headerTemplateTitle>
        {{
          'Step ' +
            (selectedIndex + 1) +
            ' of ' +
            cdkSteps.length +
            ': ' +
            (selectedStep ? selectedStep.label : cdkSteps[0].label)
        }}
      </ng-template>

      <ng-template #subHeader>
        @if (
          cdkSteps[selectedIndex]?.label !== cdkSteps[cdkSteps.length - 1].label
        ) {
          <span>
            {{ 'Next: ' + cdkSteps[selectedIndex + 1]?.label }}
          </span>
        }
      </ng-template>

      <div class="Stepper__Steps Stepper__Steps_Mobile u-flex u-column">
        @for (step of cdkSteps; track step; let i = $index) {
          <span
            class="Stepper__StepItem Stepper__StepItem_Mobile"
            [class.Stepper__StepItem_Active]="selectedIndex === i"
            [class.Stepper__StepItem_Disabled]="!step.editable"
            (click)="selectStepByIndex(i)"
          >
            {{ step.label }}
          </span>
        }
      </div>
    </ng-container>
  </accordion>

  <div class="Stepper__StepContent">
    @if (selected?.content) {
      <ng-container [ngTemplateOutlet]="selected.content"></ng-container>
    } @else {
      <p [innerHTML]="cdkSteps[selectedIndex].description"></p>
    }
  </div>
</section>
